import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import PropTypes from 'prop-types';

export const loadingStatusPropType = PropTypes.oneOf(Object.values(LOADING_STATUSES));
